<template>
    <div class="learning">
        <div class="summary">
            <div class="header"></div>
            <div class="stat">
                <img class="avatar" :src="user && user.photo?user.photo+'?x-oss-process=style/w128-h128':default_head" alt="">
                <div class="datas-wrap">
                    <div class="datas-wrap-i">
                        <div class="stimulate">{{chickenSoup}}</div>
                        <div class="datas">
                            <div class="datas-item">
                                <div class="datas-item-stat">
                                    <span class="datas-item-stat-dd">{{learn_info.today_learn_min}}</span>
                                    <span class="datas-item-stat-unit">分</span>
                                </div>
                                <div class="datas-item-title">今日学习</div>
                            </div>
                            <div class="decollator" ></div>
                            <div class="datas-item datas-item-center">
                                <div class="datas-item-stat">
                                    <span class="datas-item-stat-dd">{{learn_info.sum_study_time_h}}</span>
                                    <span class="datas-item-stat-unit">时</span>
                                    <span class="datas-item-stat-dd">{{learn_info.sum_study_time_i}}</span>
                                    <span class="datas-item-stat-unit">分</span>
                                </div>
                                <div class="datas-item-title">累积时长</div>
                            </div>
                            <div class="decollator" ></div>
                            <div class="datas-item">
                                <div class="datas-item-stat">
                                    <span class="datas-item-stat-dd">{{learn_info.count_study_sections}}</span>
                                    <span class="datas-item-stat-unit">个</span>
                                </div>
                                <div class="datas-item-title">完成课程</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="icon">
                <div class="icon_wrap">
                    <div class="icon_wrap_content">
                        <div class="icon_wrap_item" @click="bindMytaskClick">
                            <div><span class="iconfont iconbag-zuoye mr5 color-1373F7"></span></div>
                            <div class="icon_wrap_text" >作业</div>
                        </div>
                        <div class="icon_wrap_item" @click="bindMytestClick">
                            <div><span class="iconfont iconkaoshi1 mr5 color-1373F7"></span></div>
                            <div class="icon_wrap_text">考试</div>
                        </div>
                        <div class="icon_wrap_item" @click="bindQuestionClick">
                            <div><span class="iconfont iconfenshuduan mr5 color-1373F7"></span></div>
                            <div class="icon_wrap_text">随测</div>
                        </div>
                        <div class="icon_wrap_item" @click="bindCenterDatasClick">
                            <div><span class="iconfont iconpaihangbang mr5 color-1373F7"></span></div>
                            <div class="icon_wrap_text">报告</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="learn">
            <div class="learn-head">
                <div class="learn-head-title">最近学习</div>
            </div>
            <van-tabs>
                <van-tab title="课程">
                    <div class="learn-content">
                        <van-list
                                    v-model="loading"
                                    :finished="finished"
                                    finished-text="没有更多了"
                                    :immediate-check="true"
                                    @load="getMyPlayListEvent"
                                    class="content-collect"
                                >
                            <div class="learn-content-item"  v-for="(item,index) in list" :key="index" @click="bindMyCourseClick(item)"   >
                                <div class="learn-item-cover">
                                    <img class="learn-item-cover-img" :src="item.course_cover_url" alt="">
                                </div>
                                <div class="learn-item-right">
                                    <div class="learn-right-title">{{item.course_name}}</div>
                                    <div class="learn-right-section">章节 {{item.section_cnt}} | 已学 {{item.complete_rate}}</div>
                                    <div class="learn-right-progress">
                                        <div class="learn-progress-last" >上次学习 {{item.last_learn_time}}</div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-tab>
                <van-tab title="训练营">
                    <div class="learn-content">
                        <van-list
                                    v-model="training_loading"
                                    :finished="training_finished"
                                    finished-text="没有更多了"
                                    :immediate-check="true"
                                    @load="getMyTrainingListEvent"
                                    class="content-collect"
                                >
                            <div class="learn-content-item"  v-for="(item,index) in training_list" :key="index" @click="bindToTrainingClick(item)"   >
                                <div class="learn-item-cover">
                                    <img class="learn-item-cover-img" :src="item.cover_url" alt="">
                                </div>
                                <div class="learn-item-right">
                                    <div class="learn-right-title">{{item.training_stage_name}}</div>
                                    <div class="learn-right-section">训练营: {{item.training_name}} </div>
                                    <div class="learn-right-progress">
                                        <div class="learn-progress-last" v-if="0" >上次学习 {{item.last_learn_time}}</div>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Skeleton,List,PullRefresh ,Tab, Tabs} from 'vant';
import {chickenSoup} from "../../utils/poisonousChickenSoup.js";

Vue.use(Skeleton);

export default {
  components:{
        [List.name]:List,
        [PullRefresh .name]:PullRefresh,
        [Tab .name]:Tab,
        [Tabs .name]:Tabs,
  },
  data() {
    return {
        loading: true,
        user:{},
        learn_info:{
            'count_study_sections': 0,
            'sum_study_time_h':0,
            'sum_study_time_i':0,
            'today_learn_min':0,
            'count_study_sections':0,
        },
        default_head:require('../../assets/icon/default_head.png'),
        total:0,
        page:1,
        pageSize:14,
        list:[],
        loading: false,
        finished: false,
        refreshing: false,

        training_total:0,
        training_page:1,
        training_pageSize:14,
        training_list:[],
        training_loading: false,
        training_finished: false,
        training_refreshing: false,
        chickenSoup:'任何质变都来自于量变的积累',
    };
  },
  mounted() {
    this.chickenSoup = chickenSoup();
    this.loading = true;
    this.$(document).attr('title','学习中心');

    if(this.util.globalData.user.get() == '' && this.util.sessionid.get() != ''){
        this.util.server.mini_user.info({
            callback: (res => {
                this.util.globalData.user.set(res.data);
                this.util.getUserId.set(res.data.user_id);
                this.util.user_mobile.set(res.data.mobile);
                this.user=this.util.globalData.user.get();
            })
        })
    }else{
        this.user=this.util.globalData.user.get();
    }

    this.getUserStudyInfo();
    this.getMyPlayListEvent(1);
    //this.getMyTrainingListEvent(1);
  },
  methods:{
        bindCenterDatasClick:function(){
                this.$router.push(this.util.urlPrefix+'/learning_center/datas?token='+this.util.token);
        },
        bindMytaskClick:function(){
                this.$router.push(this.util.urlPrefix+'/course_task/mytask?token='+this.util.token);
        },
        bindMytestClick:function(){
                this.$router.push(this.util.urlPrefix+'/testing/mytesting?token='+this.util.token);
        },
        bindMyCourseClick:function(item){
          //curriculum/index?course_id=216&token=yxdczh0000000187
          if(item.type==7){
             this.$router.push(this.util.urlPrefix+'/fm/index?&course_id='+item.course_id+'&token='+this.util.token);
          }else{
             this.$router.push(this.util.urlPrefix+'/curriculum/index?&course_id='+item.course_id+'&token='+this.util.token);
          }
           
        },
        bindQuestionClick:function(){
            this.$router.push(this.util.urlPrefix+'/question/index?token='+this.util.token);
        },
        bindToTrainingClick:function(item){
            this.$router.push(this.util.urlPrefix+'/training/phase?stage_id='+item.training_stage_id+'&token='+this.util.token);
        },
        getUserStudyInfo(){
            var _self=this;
            this.util.server.mini_study_center.v1_user_study_info({
                callback:(res => {
                    if(res.data){
                        this.learn_info=res.data;
                        this.learn_info.today_learn_min = Math.round(this.learn_info.today_learn/60);
                    }
                })
            })
        },
        getMyPlayListEvent(page){
            var _self=this;
            if(!page){
                var pageNo = this.page;
                pageNo +=1;
                this.page=pageNo
            }else{
                this.page=page
            }
            this.util.server.mini_my.play_list({
                data:{
                    page:this.page,
                    pagesize:this.pageSize
                },
                callback: (res => {
                    const { code, data, msg } = res;

                    if(this.refreshing){
                        this.refreshing=false;
                    }
                    if(code == 1) {

                        //赋值总数量
                        if(data.total){
                            this.total = data.total;
                        }
                        //1.如果有数据
                        if(data.items && data.items.length>0) {
                            let templist = [];
                            if(page == 1){
                                templist = data.items;
                            }else{
                                //如果翻页 则在数组追加数据
                                templist = this.list.concat(data.items);
                            }
                            this.list = templist

                            //判断是否存在下一页
                            this.loading = false;

                            if(this.total*1 == this.list.length){
                                this.finished=true;
                            }

                        }else{
                            //2.无数据
                            //如果当前页为第一页 则设置页面数据为空数组
                            if (page == 1){
                                this.list=[];
                                this.finished=true;
                                this.loading = false;
                            }
                        }
                    }else{
                        this.util.showToast({
                            message: msg
                        });
                    }
                })
            });
        },
        getMyTrainingListEvent(page){
            var _self=this;
            if(page){
                this.training_page=page
            }
            this.util.server.mini_training.get_user_training_list({
                data:{
                    page:this.training_page,
                    pagesize:this.training_pageSize
                },
                callback: (res => {
                    const { code, data, msg } = res;

                    if(this.training_refreshing){
                        this.training_refreshing=false;
                    }
                    if(code == 1) {

                        //赋值总数量
                        if(data.total){
                            this.training_total = data.total;
                        }
                        //1.如果有数据
                        if(data.items && data.items.length>0) {
                            
                            let templist = [];
                            if(this.training_page == 1){
                                templist = data.items;
                            }else{
                                //如果翻页 则在数组追加数据
                                templist = this.training_list.concat(data.items);
                            }
                            this.training_list = templist

                            //判断是否存在下一页
                            this.training_loading = false;

                            if(this.training_total*1 == this.training_list.length){
                                console.log('加载完成',this.training_page);
                                this.training_finished=true;
                            }
                            this.training_page++
                        }else{
                            //2.无数据
                            //如果当前页为第一页 则设置页面数据为空数组
                            if (this.training_page == 1){
                                this.training_list=[];
                                this.training_finished=true;
                                this.training_loading = false;
                            }
                        }
                    }else{
                        this.util.showToast({
                            message: msg
                        });
                    }
                })
            });
        }
  }
};
</script>

<!-- 学习数据 -->
<style scoped>
    .learning{
        background-color: #F6F6F6;
    }
    .summary{
        position: relative;
    }
    .header{
        height: 146px;
        width: 100%;
        /* background: #1373F7; */
        background-image: linear-gradient(#9198e5,#1373F7);
    }
    .stat{
        position: absolute;
        top: 27px;
        height: 177px;
        width: 327px;
        left:50%;
        margin-left: -163px;
    }
    .datas-wrap{
        height: 142px;
        margin-top: 35px;
        border-radius: 5px;
        background: #FFFFFF;
        box-shadow: 0px 7px 18px 0px rgba(94, 88, 66, 0.07);
        border-radius: 6px;
    }
    .datas-wrap-i{
        padding-top: 38px;
    }
    .stimulate{
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1373F7;
        line-height: 22px;
    }
    .datas{
        display: flex;
        justify-content: space-between;
        height: 78px;
        width: 100%;
        padding: 10px 10px 10px 10px;
        box-sizing:border-box;
    }
    .datas-item{
        width: 72px;
    }
    .datas-item-center{
        width: 120px!important;
    }

    .datas-item-stat{
        text-align: center;
    }
    .datas-item-stat-dd{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4E4E4E;
    }
    .datas-item-stat-unit{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4E4E4E;
        padding-left: 2px;
    }
    .datas-item-title{
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #B3B3B6;
        padding-top: 5px;
    }
    .decollator{
        border-left: solid 1px #ccc;
        height: 30px;
        vertical-align: middle;
        display: inline-block;
        margin-top: 15px;
        opacity: 0.2;
    }
    .avatar{
        width: 60px;
        height: 60px;
        position: absolute;
        z-index: 1000;
        border-radius: 60px;
        left:50%;
        margin-left: -30px;
        top: 5px;
        border: 5px solid RGBA(252, 251, 249, 0.3);

    }
    .icon{
        height: 150px;
        width: 100%;
        background: #FFFFFF;
    }
    .icon_wrap{
        padding-top: 57px;
        height: 92px;
    }
    .icon_wrap_content{
        padding: 17px 24px;
        display: flex;
        box-sizing:border-box;
        justify-content: space-between;
    }
    .icon_wrap_item{
        width: 72px;
        height: 55px;
        text-align: center;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
    }
    .iconfont{
        font-size: 25px;

    }
    .color-1373F7{
        color: #1373F7;
    }
    .icon_wrap_text{
        font-size: 14px;
        color: #4A4A4A;
    }

    .learn{
        padding-top: 10px;
    }
    .learn-head{
        height: 43px;
        background-color: #FFFFFF;
    }
    .learn-content{
        background-color: #FFFFFF;
        padding-bottom: 20px;
    }

    .learn-head-title{
        font-size: 18px;
        padding-left: 20px;
        padding-top: 12px;
        padding-bottom: 12px;
        width: 100px;
        height: 20px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 5600;
        color: #4A4A4A;
        line-height: 20px;
    }
    .learn-content-item{
        padding: 15px 20px;
        height: 90px;
        display: flex;
    }
    .learn-item-cover-img{
        width: 120px;
        height: 90px;
        object-fit: cover;
    }
    .learn-item-cover{
        width: 125px;
        height: 90px;
    }
    .learn-item-right{
        padding-left: 13px;
         height: 90px;
    }
    .learn-right-title{
        height: 40px;
        font-size: 14px;
        font-weight: 600;
        color: #666666;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
    }
    .learn-right-section{
        font-size: 12px;
        color: #999999;
    }
    .learn-right-progress{
        padding-top: 20px;
        display: flex;
        justify-content: space-between;
    }
    .learn-progress-last{
        font-size: 12px;
        color: #9B9B9B;
    }
    .learn-progress-rate{
        font-size: 12px;
        color: #9B9B9B;
    }
    .learn >>> .van-tab{
        flex: none !important;
    }
    .learn >>> .van-tabs__nav {
        padding-left: 18px;
    }
    .learn >>> .van-tabs__line{
        width: 12px;
    }
    .learn >>> .van-tab--active{
        color: #f34807;
        font-size: 16px !important;
    }
</style>
